__webpack_require__.p = "/mint_static/";